import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../config';
import GalleryModal from './Modals/GalleryModal';
import GalleryItem from './GalleryItem';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';
import { findOne } from '../../../actions/permissions';
import GalleryDeleteConfirmationModal from '../../../components/GalleryDeleteConfirmModal';
// import GalleryUpdateModal from '../../../components/GalleryUpdateModal';

let $ = window.jQuery;

export default class Gallery extends Component {
    state = {
        documents: [],
        selectedCategory: '',
        selectedDocumentId: 0,
        isSaving: false,
        selectedDocument: null
    };

    getGalleryImages = () => {
        let url = `${config.apiUrl}dental/galleries/${this.props.patientId}`;

        axios.get(url).then((res) => {
            this.setState({
                documents: res.data.data
            });
            
        }).catch((res) => {
            console.log('failed in getting documents', res);
        });
    };

    initGalleryView = () => {
        $('#js-grid-juicy-projects').cubeportfolio({
            filters: '#js-filters-full-width',
            loadMore: '#js-loadMore-juicy-projects',
            loadMoreAction: 'click',
            layoutMode: 'grid',
            defaultFilter: '*',
            animationType: 'quicksand',
            gapHorizontal: 30,
            gapVertical: 20,
            gridAdjustment: 'responsive',
            mediaQueries: [{
                width: 1500,
                cols: 5
            }, {
                width: 1100,
                cols: 4
            }, {
                width: 800,
                cols: 3
            }, {
                width: 480,
                cols: 2
            }, {
                width: 320,
                cols: 1
            }],
            caption: 'zoom',
            displayType: 'sequentially',
            displayTypeSpeed: 100,

            // lightbox
            lightboxDelegate: '.cbp-lightbox',
            lightboxGallery: true,
            lightboxTitleSrc: 'data-title',
            lightboxCounter: '<div class="cbp-popup-lightbox-counter">{{current}} of {{total}}</div>',

            // singlePage popup
            singlePageDelegate: '.cbp-singlePage',
            singlePageDeeplinking: true,
            singlePageStickyNavigation: true,
            singlePageCounter: '<div class="cbp-popup-singlePage-counter">{{current}} of {{total}}</div>',
            singlePageCallback: function(url, element) {
                // to update singlePage content use the following method: this.updateSinglePage(yourContent)
                var t = this;

                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'html',
                    timeout: 10000
                })
                    .done(function(result) {
                        t.updateSinglePage(result);
                    })
                    .fail(function() {
                        t.updateSinglePage('AJAX Error! Please refresh the page!');
                    });
            },
        });
    };

    destroyGalleryView = () => {
        $('#js-grid-juicy-projects').cubeportfolio('destroy');
    };

    handleOnNewImageUploaded = (document) => {
        this.destroyGalleryView();

        this.setState({
            documents: this.state.documents.concat([document])
        }, () => {
            this.initGalleryView();
        });

    };

    handleOpenGalleryUpload = (props) => {
        if (! findOne(this.props.permissions, ['gallery.add', 'gallery.*'])) {
            this.props.showNotification('error', 'You dont have the correct permission to upload new documents');

            return;
        }

        this.setState({
            selectedDocument: props
        }, () => {
            $('#myModalXray').modal('show');
        });
    };

    handleDeleteGalleryItem = (documentId) => {
        this.setState({
            selectedDocumentId: documentId
        }, () => {
            $('#confirmDeleteGalleryItem').modal('show');
        });
    };

    handleDeleteCancel = () => {
        this.setState({
            selectedDocumentId: 0,
            isSaving: false
        }, () => {
            $('#confirmDeleteGalleryItem').modal('hide');
        });
    };

    handleConfirmDeleteGalleryItem = () => {
        if (this.state.selectedDocumentId === 0) {
            return;
        }

        this.setState({
            isSaving: true
        });

        let url = `${config.apiUrl}dental/galleries/${this.state.selectedDocumentId}`;

        axios.delete(url).then((res) => {
            let documents = this.state.documents;
            let newDocuments = documents.filter((item) => item.id !== this.state.selectedDocumentId);

            console.log(newDocuments);

            this.destroyGalleryView();

            this.setState({
                documents: newDocuments,
                isSaving: false
            }, () => {
                this.initGalleryView();
                $('#confirmDeleteGalleryItem').modal('hide');
                this.props.showNotification('success', 'Successfully deleted gallery item');
            });

        }).catch((res) => {
            console.log('failed in getting documents', res);

            $('#confirmDeleteGalleryItem').modal('hide');
            this.props.showNotification('error', 'Failed deleting gallery item');
        });
    };

    componentDidMount() {
        if(sessionStorage.getItem('lastTab') === 'galleryPage') {
            this.initGalleryView();
        }

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'galleryPage'
            });

            if (index >= 0) {
                try {
                    this.initGalleryView();
                } catch (e) {
                    console.log('Gallery Already Initialized')
                }
            }
        })
    }

    componentWillMount() {
        this.getGalleryImages();
    }

    render() {
        return (
            <div className="portlet light ">

                <div className="portlet-body">

                    <div className="portfolio-content portfolio-1">
                        <div id="js-filters-full-width" className="cbp-l-filters-button cbp-l-filters-alignCenter">
                            <div data-filter="*"
                                 onClick={e => this.setState({ selectedCategory: '' })}
                                 className="cbp-filter-item-active cbp-filter-item"> All
                                <div className="cbp-filter-counter"></div>
                            </div>
                            <div data-filter=".xray"
                                 onClick={e => this.setState({ selectedCategory: 'xray' })}
                                 className="cbp-filter-item"> X-Ray
                                <div className="cbp-filter-counter"></div>
                            </div>
                            <div data-filter=".before-after"
                                 onClick={e => this.setState({ selectedCategory: 'before-after' })}
                                 className="cbp-filter-item"> Before and After
                                <div className="cbp-filter-counter"></div>
                            </div>
                            <div data-filter=".videos"
                                 onClick={e => this.setState({ selectedCategory: 'videos' })}
                                 className="cbp-filter-item"> Videos
                                <div className="cbp-filter-counter"></div>
                            </div>
                            <div data-filter=".others"
                                 onClick={e => this.setState({ selectedCategory: 'others' })}
                                 className="cbp-filter-item"> Others
                                <div className="cbp-filter-counter"></div>
                            </div>
                        </div>

                        <hr/>

                        <div id="js-grid-juicy-projects" className="cbp cbp-l-grid-mosaic">
                            {this.state.documents.map((document, i) => {
                                return <GalleryItem onOpenGalleryUpload={this.handleOpenGalleryUpload}
                                                    onDeleteGalleryItem={this.handleDeleteGalleryItem}
                                                    {...document} key={i} />
                            })}
                        </div>
                    </div>
                </div>

                <FloatingActionButton
                    title="Add New Document"
                    onClick={this.handleOpenGalleryUpload} />

                <GalleryModal patientId={this.props.patientId}
                              showNotification={this.props.showNotification}
                              hideNotification={this.props.hideNotification}
                              onNewImageUploaded={this.handleOnNewImageUploaded}
                              selectedCategory={this.state.selectedCategory} />

                {/*<GalleryUpdateModal patientId={this.props.patientId}*/}
                              {/*selectedDocument={this.state.selectedDocument}*/}
                              {/*showNotification={this.props.showNotification}*/}
                              {/*hideNotification={this.props.hideNotification}*/}
                              {/*onNewImageUploaded={this.handleOnNewImageUploaded}*/}
                              {/*selectedCategory={this.state.selectedCategory} />*/}

                <GalleryDeleteConfirmationModal isSaving={this.state.isSaving}
                                                onConfirm={this.handleConfirmDeleteGalleryItem}
                                                onCancel={this.handleDeleteCancel} />
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Gallery/Gallery.js
 **/